import { IconPropsType } from './icon-props'

export const CheckIcon = ({
  width = 28,
  height = 28,
  color
}: IconPropsType) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 50.000000 50.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,50.000000) scale(0.100000,-0.100000)"
        fill={color ?? '#000000'}
        stroke="none"
      >
        <path
          d="M155 456 c-60 -28 -87 -56 -114 -116 -36 -79 -19 -183 42 -249 33
-36 115 -71 167 -71 52 0 134 35 167 71 34 37 63 110 63 159 0 52 -35 134 -71
167 -37 34 -110 63 -159 63 -27 0 -65 -10 -95 -24z m205 -112 c0 -10 -113
-174 -120 -174 -3 0 -26 20 -50 45 -50 51 -34 63 17 13 22 -21 36 -29 41 -22
70 108 96 144 103 144 5 0 9 -3 9 -6z"
        />
      </g>
    </svg>
  )
}
